import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import {
  WorkspaceAddModeCallable,
  type WorkspaceAddModeCallableProps,
} from "@/action-dialog/callables/WorkspaceAddModeCallable";
import type { WorkspaceAddMode } from "@/action-dialog/dialogs/WorkspaceAddModeDialog";
import { alwaysAddAsReference } from "@/action-dialog/workspaceAddModePreference";

export type { WorkspaceAddMode } from "@/action-dialog/dialogs/WorkspaceAddModeDialog";

/**
 * The reference-or-copy chooser for same-workspace Add from workspace picks
 * (canvas and chat). Resolves null when dismissed — the pick is abandoned.
 * The dialog's "always add as a live reference" checkbox stores a skip:
 * once set, the chooser resolves to reference without showing (reset in
 * Settings → Account). Cross-workspace picks use their own workflow and
 * always ask.
 */
export function runWorkspaceAddModeWorkflow(
  params: WorkspaceAddModeCallableProps,
): Promise<WorkspaceAddMode | null> {
  if (alwaysAddAsReference()) return Promise.resolve("reference");
  return withActionDialogLock(() => WorkspaceAddModeCallable.call(params));
}
